import React from 'react';

export default function BackButton({ onClick, style = {}, ariaLabel = "Back", position = "absolute", top = 10, left = 10, zIndex = 10001 }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        position,
        top,
        left,
        background: 'rgba(0,0,0,0.6)',
        border: 'none',
        color: '#fff',
        fontSize: '1.8rem',
        cursor: 'pointer',
        zIndex,
        boxShadow: '0 2px 16px rgba(0,0,0,0.25)',
        borderRadius: '50%',
        width: 48,
        height: 48,
        lineHeight: '48px',
        textAlign: 'center',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
      aria-label={ariaLabel}
    >←</button>
  );
}